export const info = {
    about: "I am a sophomore majoring in Computer Engineering and Computer Science at the University of Wisconsin Madison. In my spare time I am the Software Team Lead for Badgerloop, UW-Madison's Hyperloop team." +
    " My favorite restaurant is Monty's Blue Plate Diner and I enjoy going out in the great outdoors.",
    homepage: "I'm a student, traveler, and developer. Take a look around to see what I've been involved in."
};


// WEBPACK FOOTER //
// ./src/about.js